// This request layer helps jest mock
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

export const axiosRequest = (config: AxiosRequestConfig): AxiosPromise<any> => {
  return axios(config);
};
